import { render, staticRenderFns } from "./Emblem.global.vue?vue&type=template&id=0417ca88&scoped=true&lang=pug&"
import script from "./Emblem.global.vue?vue&type=script&lang=ts&"
export * from "./Emblem.global.vue?vue&type=script&lang=ts&"
import style0 from "./Emblem.global.vue?vue&type=style&index=0&id=0417ca88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0417ca88",
  null
  
)

export default component.exports